module.exports = __webpack_public_path__ + "img/img1.7b60f0b2.png";